import { useSelector } from 'react-redux';

import {
  selectIsClientIpBlocked,
  selectIsClientIpLoading,
  selectIsGoogleCaptchaIsDisabled,
  selectIsScannerLoading,
} from '@lib/core/service/selectors/technical';

export const useTechnical = () => {
  return {
    isCaptchaDisabled: useSelector(selectIsGoogleCaptchaIsDisabled),
    isClientIpBlocked: useSelector(selectIsClientIpBlocked),
    isClientIpLoading: useSelector(selectIsClientIpLoading),
    isScannerLoading: useSelector(selectIsScannerLoading),
  };
};
